/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.



//==============================================================
// START Enums and Input Objects
//==============================================================


export enum OdProtosAgentsData_AgentLead_State {
  AGENTS_PROPOSED = "AGENTS_PROPOSED",
  ASSIGNED = "ASSIGNED",
  ASSIGNMENT_NOT_POSSIBLE = "ASSIGNMENT_NOT_POSSIBLE",
  BROKERAGE_ACCEPTED = "BROKERAGE_ACCEPTED",
  BROKERAGE_PROPOSED = "BROKERAGE_PROPOSED",
  CANDIDATE_AGENTS_PROPOSED = "CANDIDATE_AGENTS_PROPOSED",
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  DELETED = "DELETED",
  IN_PROGRESS = "IN_PROGRESS",
  MANUAL_ASSIGNMENT_REQUIRED = "MANUAL_ASSIGNMENT_REQUIRED",
  SELECTING_AGENT = "SELECTING_AGENT",
  SELECTING_BROKERAGE = "SELECTING_BROKERAGE",
  SELECT_AGENT_CANDIDATE = "SELECT_AGENT_CANDIDATE",
  UNKNOWN = "UNKNOWN",
  UNSERVICEABLE = "UNSERVICEABLE",
}

/**
 * The names must be the uppercase versions of the market identifiers in web.
 * Update region.proto if any market is added/removed from here.
 */
export enum OdProtosCommonMarket_Market {
  ALBUQUERQUE_NM = "ALBUQUERQUE_NM",
  ASHEVILLE_NC = "ASHEVILLE_NC",
  ATLANTA = "ATLANTA",
  AUSTIN = "AUSTIN",
  BAKERSFIELD_CA = "BAKERSFIELD_CA",
  BALTIMORE_MD = "BALTIMORE_MD",
  BIRMINGHAM_AL = "BIRMINGHAM_AL",
  BOISE = "BOISE",
  BOSTON_MA = "BOSTON_MA",
  CENTRAL_CALIFORNIA_CA = "CENTRAL_CALIFORNIA_CA",
  CHARLESTON_SC = "CHARLESTON_SC",
  CHARLOTTE = "CHARLOTTE",
  CHATTANOOGA = "CHATTANOOGA",
  CHICAGO_IL = "CHICAGO_IL",
  CINCINNATI_OH = "CINCINNATI_OH",
  CINCINNATI_OK = "CINCINNATI_OK",
  CLARKSVILLE_KY_TN = "CLARKSVILLE_KY_TN",
  CLEVELAND_OH = "CLEVELAND_OH",
  COLORADO_SPRINGS_CO = "COLORADO_SPRINGS_CO",
  COLUMBIA_SC = "COLUMBIA_SC",
  COLUMBUS_OH = "COLUMBUS_OH",
  CORPUS_CHRISTI_TX = "CORPUS_CHRISTI_TX",
  DALLAS = "DALLAS",
  DENVER = "DENVER",
  DETROIT_MI = "DETROIT_MI",
  FORT_COLLINS_CO = "FORT_COLLINS_CO",
  GREENSBORO_NC = "GREENSBORO_NC",
  GREENVILLE_SC = "GREENVILLE_SC",
  HOUSTON = "HOUSTON",
  HUNTSVILLE_AL = "HUNTSVILLE_AL",
  INDIANAPOLIS_IN = "INDIANAPOLIS_IN",
  JACKSONVILLE = "JACKSONVILLE",
  JOHNSON_CITY_TN = "JOHNSON_CITY_TN",
  KANSAS_CITY = "KANSAS_CITY",
  KILLEEN_TX = "KILLEEN_TX",
  KNOXVILLE_TN = "KNOXVILLE_TN",
  LAS_VEGAS = "LAS_VEGAS",
  LOS_ANGELES = "LOS_ANGELES",
  LOUISVILLE_IN_KY = "LOUISVILLE_IN_KY",
  MEMPHIS_TN = "MEMPHIS_TN",
  MIAMI_FL = "MIAMI_FL",
  MILWAUKEE_WAUKESHA_WI = "MILWAUKEE_WAUKESHA_WI",
  MINNEAPOLIS = "MINNEAPOLIS",
  NASHVILLE = "NASHVILLE",
  NEW_YORK_NEW_JERSEY = "NEW_YORK_NEW_JERSEY",
  NORTHERN_COLORADO = "NORTHERN_COLORADO",
  OKLAHOMA_CITY_OK = "OKLAHOMA_CITY_OK",
  ORLANDO = "ORLANDO",
  PALM_BAY_FL = "PALM_BAY_FL",
  PHILADELPHIA_PA = "PHILADELPHIA_PA",
  PHOENIX = "PHOENIX",
  PORTLAND = "PORTLAND",
  PRESCOTT_AZ = "PRESCOTT_AZ",
  PROVIDENCE_RI = "PROVIDENCE_RI",
  RALEIGH = "RALEIGH",
  RENO_NV = "RENO_NV",
  RICHMOND_VA = "RICHMOND_VA",
  RIVERSIDE = "RIVERSIDE",
  SACRAMENTO = "SACRAMENTO",
  SALT_LAKE_CITY = "SALT_LAKE_CITY",
  SAN_ANTONIO = "SAN_ANTONIO",
  SAN_DIEGO_CA = "SAN_DIEGO_CA",
  SAVANNAH_GA = "SAVANNAH_GA",
  SEATTLE_WA = "SEATTLE_WA",
  SF_BAY_AREA = "SF_BAY_AREA",
  SOUTHWEST_FL = "SOUTHWEST_FL",
  SPRINGFIELD_MO = "SPRINGFIELD_MO",
  ST_LOUIS = "ST_LOUIS",
  TAMPA = "TAMPA",
  TUCSON = "TUCSON",
  TULSA_OK = "TULSA_OK",
  UNKNOWN = "UNKNOWN",
  WASHINGTON_DC = "WASHINGTON_DC",
  WICHITA_KS = "WICHITA_KS",
}

/**
 * Classifications for the type of phone number of the Contact.
 * 
 * Next ID: 4
 */
export enum OdProtosCustomerV1Data_Phone_PhoneType {
  HOME = "HOME",
  MOBILE = "MOBILE",
  OTHER = "OTHER",
  WORK = "WORK",
}

export enum OdProtosListingsData_CustomerDeclineReason {
  DECLINE_REASON_COMPETITOR = "DECLINE_REASON_COMPETITOR",
  DECLINE_REASON_DIRECT_SALE_ONLY = "DECLINE_REASON_DIRECT_SALE_ONLY",
  DECLINE_REASON_NON_RESPONSIVE = "DECLINE_REASON_NON_RESPONSIVE",
  DECLINE_REASON_NOT_BUYING_OR_SELLING = "DECLINE_REASON_NOT_BUYING_OR_SELLING",
  UNKNOWN_DECLINE_REASON = "UNKNOWN_DECLINE_REASON",
}

export enum OdProtosListingsData_ExperiencePartnerSupportRequestType {
  SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION = "SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION",
  SUPPORT_REQUEST_TYPE_REPAIR_ASKS = "SUPPORT_REQUEST_TYPE_REPAIR_ASKS",
  SUPPORT_REQUEST_TYPE_SELLER_CONTACT = "SUPPORT_REQUEST_TYPE_SELLER_CONTACT",
  UNKNOWN_SUPPORT_REQUEST_TYPE = "UNKNOWN_SUPPORT_REQUEST_TYPE",
}

export enum OdProtosListingsData_ListingPresentationType {
  EMAIL = "EMAIL",
  IN_PERSON = "IN_PERSON",
  PHONE = "PHONE",
  UNKNOWN_PRESENTATION_TYPE = "UNKNOWN_PRESENTATION_TYPE",
  VIDEO_CALL = "VIDEO_CALL",
}

export enum OdProtosListingsData_Listing_State {
  AGENT_ASSIGNMENT = "AGENT_ASSIGNMENT",
  IN_CONTRACT = "IN_CONTRACT",
  LEAD_TERMINATED = "LEAD_TERMINATED",
  LISTING_ACTIVE = "LISTING_ACTIVE",
  LISTING_AGREEMENT_SIGNED = "LISTING_AGREEMENT_SIGNED",
  LISTING_TERMINATED = "LISTING_TERMINATED",
  NOT_LISTED = "NOT_LISTED",
  OWNER_LIST_DECISION = "OWNER_LIST_DECISION",
  SOLD = "SOLD",
  UNKNOWN = "UNKNOWN",
}

/**
 * Next ID: 21
 */
export enum OdProtosListingsData_LwcProduct_State {
  AGENT_ASSIGNED = "AGENT_ASSIGNED",
  CONVERTED_DIRECT_SALE = "CONVERTED_DIRECT_SALE",
  CONVERTED_LISTING = "CONVERTED_LISTING",
  CREATED = "CREATED",
  DELETED = "DELETED",
  DNC_COMPETITOR = "DNC_COMPETITOR",
  DNC_DIRECT_SALE_ONLY = "DNC_DIRECT_SALE_ONLY",
  DNC_NON_RESPONSIVE = "DNC_NON_RESPONSIVE",
  DNC_NOT_BUYING_SELLING = "DNC_NOT_BUYING_SELLING",
  DNC_NOT_INTERESTED = "DNC_NOT_INTERESTED",
  FIRST_CONTACT_ATTEMPTED = "FIRST_CONTACT_ATTEMPTED",
  LISTING_INITIATED = "LISTING_INITIATED",
  LISTING_PRESENTATION_COMPLETE = "LISTING_PRESENTATION_COMPLETE",
  LISTING_PRESENTATION_SCHEDULED = "LISTING_PRESENTATION_SCHEDULED",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
  NO_SALE = "NO_SALE",
  SELECTED_DIRECT_SALE = "SELECTED_DIRECT_SALE",
  SELECTED_LISTING = "SELECTED_LISTING",
  SOLD_ON_MARKET = "SOLD_ON_MARKET",
  SOLD_TO_OPENDOOR = "SOLD_TO_OPENDOOR",
  UNKNOWN = "UNKNOWN",
}

export enum OdProtosListingsData_NoteType {
  AGENT_NOTE = "AGENT_NOTE",
  CEP_NOTE = "CEP_NOTE",
  LEAD_PASS_BACK_NOTE = "LEAD_PASS_BACK_NOTE",
  UNKNOWN_NOTE = "UNKNOWN_NOTE",
}

/**
 * Next ID: 4
 */
export enum OdProtosListingsData_PARNDidNotCloseReason {
  NO_ACCEPTABLE_OFFERS = "NO_ACCEPTABLE_OFFERS",
  OTHER = "OTHER",
  PLANS_CHANGED = "PLANS_CHANGED",
  UNKNOWN_REASON_DID_NOT_CLOSE = "UNKNOWN_REASON_DID_NOT_CLOSE",
}

/**
 * Next ID: 5
 */
export enum OdProtosListingsData_PARNDidNotConvertReason {
  NOT_INTERESTED = "NOT_INTERESTED",
  PARN_COMPETITOR = "PARN_COMPETITOR",
  PARN_NON_RESPONSIVE = "PARN_NON_RESPONSIVE",
  PARN_NOT_BUYING_OR_SELLING = "PARN_NOT_BUYING_OR_SELLING",
  UNKNOWN_REASON_DID_NOT_CONVERT = "UNKNOWN_REASON_DID_NOT_CONVERT",
}

/**
 * Next ID: 14
 */
export enum OdProtosListingsData_PARN_State {
  CREATED = "CREATED",
  DID_NOT_CLOSE_NO_ACCEPTABLE_OFFERS = "DID_NOT_CLOSE_NO_ACCEPTABLE_OFFERS",
  DID_NOT_CLOSE_OTHER = "DID_NOT_CLOSE_OTHER",
  DID_NOT_CLOSE_PLANS_CHANGED = "DID_NOT_CLOSE_PLANS_CHANGED",
  DID_NOT_CONVERT_COMPETITOR = "DID_NOT_CONVERT_COMPETITOR",
  DID_NOT_CONVERT_NON_RESPONSIVE = "DID_NOT_CONVERT_NON_RESPONSIVE",
  DID_NOT_CONVERT_NOT_BUYING_SELLING = "DID_NOT_CONVERT_NOT_BUYING_SELLING",
  DID_NOT_CONVERT_NOT_INTERESTED = "DID_NOT_CONVERT_NOT_INTERESTED",
  FIRST_CONTACT_ATTEMPTED = "FIRST_CONTACT_ATTEMPTED",
  FIRST_CONTACT_MADE = "FIRST_CONTACT_MADE",
  LISTING_INITIATED = "LISTING_INITIATED",
  SELECTED_PARN = "SELECTED_PARN",
  SOLD = "SOLD",
  UNKNOWN = "UNKNOWN",
}

/**
 * The options for sort direction
 * Next ID: 2
 */
export enum OdProtosPartnershipData_ReportingSearchFilters_Direction {
  ASC = "ASC",
  DESC = "DESC",
}

/**
 * The options for ordering sorted results 
 * Next ID: 6
 */
export enum OdProtosPartnershipData_ReportingSearchFilters_OrderBy {
  CUSTOMER_NAME = "CUSTOMER_NAME",
  LEAD_CREATED = "LEAD_CREATED",
  OFFER_SENT = "OFFER_SENT",
  PARTNER_DISPLAY_NAME = "PARTNER_DISPLAY_NAME",
  REGION_IDENTIFIER = "REGION_IDENTIFIER",
  SALES_REFERRER = "SALES_REFERRER",
}

/**
 * A Product that we can offer to the seller.
 * Next ID: 11
 */
export enum OdProtosSellCommon_Product {
  AGENT_REFERRAL = "AGENT_REFERRAL",
  BUY_WITH_OPENDOOR = "BUY_WITH_OPENDOOR",
  EXTERNAL_LISTING_AGENT = "EXTERNAL_LISTING_AGENT",
  LIST_WITH_CERTAINTY = "LIST_WITH_CERTAINTY",
  LIST_WITH_OPENDOOR = "LIST_WITH_OPENDOOR",
  OPENDOOR_BACKED_OFFERS = "OPENDOOR_BACKED_OFFERS",
  OPENDOOR_DIRECT = "OPENDOOR_DIRECT",
  REIT = "REIT",
  SELL_WITH_EXCLUSIVES = "SELL_WITH_EXCLUSIVES",
  SELL_WITH_UPSIDE = "SELL_WITH_UPSIDE",
  UNKNOWN_PRODUCT = "UNKNOWN_PRODUCT",
}

/**
 * Next ID: 5
 */
export enum OdProtosWebData_ExperimentsEnum {
  GUARANTEE_AT_PRELIM_OFFER = "GUARANTEE_AT_PRELIM_OFFER",
  LWC_WITH_ALA = "LWC_WITH_ALA",
  NO_VIRTUAL_ASSESSMENT = "NO_VIRTUAL_ASSESSMENT",
  SELLER_LOW_OFFER_CONFIDENCE = "SELLER_LOW_OFFER_CONFIDENCE",
  UNKNOWN_EXPERIMENT = "UNKNOWN_EXPERIMENT",
}

/**
 * Next ID: 5
 */
export enum OdProtosWebData_ORVAState {
  ORVA_ATTEMPTED = "ORVA_ATTEMPTED",
  ORVA_COMPLETED = "ORVA_COMPLETED",
  ORVA_EXPIRED = "ORVA_EXPIRED",
  ORVA_NOT_STARTED = "ORVA_NOT_STARTED",
  ORVA_SCHEDULED = "ORVA_SCHEDULED",
}

/**
 * Next ID: 16
 */
export enum OdProtosWebData_Offer_State {
  ACCEPTED = "ACCEPTED",
  ACCEPTED_OFFER = "ACCEPTED_OFFER",
  CLOSED = "CLOSED",
  CONTINGENCY_RELEASED = "CONTINGENCY_RELEASED",
  DRAFT = "DRAFT",
  EXPIRED = "EXPIRED",
  FINAL_OFFER_UNRELEASED = "FINAL_OFFER_UNRELEASED",
  IN_CONTRACT = "IN_CONTRACT",
  READY_TO_SEND = "READY_TO_SEND",
  REQUESTED_TO_LIST = "REQUESTED_TO_LIST",
  SEND_IN_PROGRESS = "SEND_IN_PROGRESS",
  SENT = "SENT",
  UNKNOWN = "UNKNOWN",
  VIEWING = "VIEWING",
  WAITING_FOR_LIST_WITH_CERTAINTY = "WAITING_FOR_LIST_WITH_CERTAINTY",
  WAITING_FOR_OTHER_OFFERS = "WAITING_FOR_OTHER_OFFERS",
  WITHDRAWN = "WITHDRAWN",
}

/**
 * The enum here should match with the following defined in Web
 * https: // github.com/opendoor-labs/web/blob/4ec863aaf36a82b0c9df10b4de196020d142c7c6/app/models/virtual_assessment_recording.rb#L8
 * Next ID: 10
 */
export enum OdProtosWebData_RecordedFeature {
  BACKYARD = "BACKYARD",
  FRONTYARD = "FRONTYARD",
  INTERIOR = "INTERIOR",
  KITCHEN = "KITCHEN",
  LIVING_ROOM = "LIVING_ROOM",
  MASTER_BEDROOM_AND_BATHROOM = "MASTER_BEDROOM_AND_BATHROOM",
  SELLER_DISCLOSURE_DOCUMENT = "SELLER_DISCLOSURE_DOCUMENT",
  UNKNOWN_RECORDED_FEATURE = "UNKNOWN_RECORDED_FEATURE",
  UTILITIES = "UTILITIES",
  WHOLE_HOME = "WHOLE_HOME",
}

/**
 * Next ID: 3
 */
export enum OdProtosWebData_SSVAState {
  SSVA_COMPLETED = "SSVA_COMPLETED",
  SSVA_IN_PROGRESS = "SSVA_IN_PROGRESS",
  SSVA_NOT_STARTED = "SSVA_NOT_STARTED",
}

/**
 * Next ID: 6
 */
export enum OdProtosWebData_Underwriting_State {
  APPROVED = "APPROVED",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  ESCALATED = "ESCALATED",
  UNKNOWN = "UNKNOWN",
  WALKED = "WALKED",
}

/**
 * `FieldMask` represents a set of symbolic field paths, for example:
 * 
 *     paths: "f.a"
 *     paths: "f.b.d"
 * 
 * Here `f` represents a field in some root message, `a` and `b`
 * fields in the message found in `f`, and `d` a field found in the
 * message in `f.b`.
 * 
 * Field masks are used to specify a subset of fields that should be
 * returned by a get operation or modified by an update operation.
 * Field masks also have a custom JSON encoding (see below).
 * 
 * # Field Masks in Projections
 * 
 * When used in the context of a projection, a response message or
 * sub-message is filtered by the API to only contain those fields as
 * specified in the mask. For example, if the mask in the previous
 * example is applied to a response message as follows:
 * 
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *         x : 2
 *       }
 *       y : 13
 *     }
 *     z: 8
 * 
 * The result will not contain specific values for fields x,y and z
 * (their value will be set to the default, and omitted in proto text
 * output):
 * 
 * 
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *       }
 *     }
 * 
 * A repeated field is not allowed except at the last position of a
 * paths string.
 * 
 * If a FieldMask object is not present in a get operation, the
 * operation applies to all fields (as if a FieldMask of all fields
 * had been specified).
 * 
 * Note that a field mask does not necessarily apply to the
 * top-level response message. In case of a REST get operation, the
 * field mask applies directly to the response, but in case of a REST
 * list operation, the mask instead applies to each individual message
 * in the returned resource list. In case of a REST custom method,
 * other definitions may be used. Where the mask applies will be
 * clearly documented together with its declaration in the API.  In
 * any case, the effect on the returned resource/resources is required
 * behavior for APIs.
 * 
 * # Field Masks in Update Operations
 * 
 * A field mask in update operations specifies which fields of the
 * targeted resource are going to be updated. The API is required
 * to only change the values of the fields as specified in the mask
 * and leave the others untouched. If a resource is passed in to
 * describe the updated values, the API ignores the values of all
 * fields not covered by the mask.
 * 
 * If a repeated field is specified for an update operation, new values will
 * be appended to the existing repeated field in the target resource. Note that
 * a repeated field is only allowed in the last position of a `paths` string.
 * 
 * If a sub-message is specified in the last position of the field mask for an
 * update operation, then new value will be merged into the existing sub-message
 * in the target resource.
 * 
 * For example, given the target message:
 * 
 *     f {
 *       b {
 *         d: 1
 *         x: 2
 *       }
 *       c: [1]
 *     }
 * 
 * And an update message:
 * 
 *     f {
 *       b {
 *         d: 10
 *       }
 *       c: [2]
 *     }
 * 
 * then if the field mask is:
 * 
 *  paths: ["f.b", "f.c"]
 * 
 * then the result will be:
 * 
 *     f {
 *       b {
 *         d: 10
 *         x: 2
 *       }
 *       c: [1, 2]
 *     }
 * 
 * An implementation may provide options to override this default behavior for
 * repeated and message fields.
 * 
 * In order to reset a field's value to the default, the field must
 * be in the mask and set to the default value in the provided resource.
 * Hence, in order to reset all fields of a resource, provide a default
 * instance of the resource and set all fields in the mask, or do
 * not provide a mask as described below.
 * 
 * If a field mask is not present on update, the operation applies to
 * all fields (as if a field mask of all fields has been specified).
 * Note that in the presence of schema evolution, this may mean that
 * fields the client does not know and has therefore not filled into
 * the request will be reset to their default. If this is unwanted
 * behavior, a specific service may require a client to always specify
 * a field mask, producing an error if not.
 * 
 * As with get operations, the location of the resource which
 * describes the updated values in the request message depends on the
 * operation kind. In any case, the effect of the field mask is
 * required to be honored by the API.
 * 
 * ## Considerations for HTTP REST
 * 
 * The HTTP kind of an update operation which uses a field mask must
 * be set to PATCH instead of PUT in order to satisfy HTTP semantics
 * (PUT must only be used for full updates).
 * 
 * # JSON Encoding of Field Masks
 * 
 * In JSON, a field mask is encoded as a single string where paths are
 * separated by a comma. Fields name in each path are converted
 * to/from lower-camel naming conventions.
 * 
 * As an example, consider the following message declarations:
 * 
 *     message Profile {
 *       User user = 1;
 *       Photo photo = 2;
 *     }
 *     message User {
 *       string display_name = 1;
 *       string address = 2;
 *     }
 * 
 * In proto a field mask for `Profile` may look as such:
 * 
 *     mask {
 *       paths: "user.display_name"
 *       paths: "photo"
 *     }
 * 
 * In JSON, the same mask is represented as below:
 * 
 *     {
 *       mask: "user.displayName,photo"
 *     }
 * 
 * # Field Masks and Oneof Fields
 * 
 * Field masks treat fields in oneofs just as regular fields. Consider the
 * following message:
 * 
 *     message SampleMessage {
 *       oneof test_oneof {
 *         string name = 4;
 *         SubMessage sub_message = 9;
 *       }
 *     }
 * 
 * The field mask can be:
 * 
 *     mask {
 *       paths: "name"
 *     }
 * 
 * Or:
 * 
 *     mask {
 *       paths: "sub_message"
 *     }
 * 
 * Note that oneof type names ("test_oneof" in this case) cannot be used in
 * paths.
 * 
 * ## Field Mask Verification
 * 
 * The implementation of any API method which has a FieldMask type field in the
 * request should verify the included field paths, and return an
 * `INVALID_ARGUMENT` error if any path is unmappable.
 */
export interface GoogleProtobuf_FieldMaskInput {
  paths?: string[] | null;
}

export interface OdProtosListingsData_KeyTimestampPairInput {
  key?: string | null;
  timestamp?: any | null;
}

export interface OdProtosListingsData_PARNKeyTimestampPairInput {
  key?: string | null;
  timestamp?: any | null;
}

export interface OdProtosListingsServices_SetDetailsRequestInput {
  id?: string | null;
  nextState?: OdProtosListingsData_Listing_State | null;
  listingPrice?: number | null;
  contractPrice?: number | null;
  soldPrice?: number | null;
  grossCommission?: number | null;
  timestampOverrides?: OdProtosListingsServices_SetDetailsRequest_TimestampOverrideInput[] | null;
  updateMask?: GoogleProtobuf_FieldMaskInput | null;
}

export interface OdProtosListingsServices_SetDetailsRequest_TimestampOverrideInput {
  state?: OdProtosListingsData_Listing_State | null;
  timestamp?: any | null;
}

export interface OdProtosListingsServices_SetPARNTimestampsRequestInput {
  parnId?: string | null;
  keyTimestampPairs?: OdProtosListingsData_PARNKeyTimestampPairInput[] | null;
}

export interface OdProtosListingsServices_SetTimestampsRequestInput {
  lwcProductId?: string | null;
  keyTimestampPairs?: OdProtosListingsData_KeyTimestampPairInput[] | null;
}

/**
 * Next ID: 13
 */
export interface OdProtosPartnershipData_ReportingSearchFiltersInput {
  searchQuery?: string | null;
  startDate?: any | null;
  endDate?: any | null;
  updatedSince?: any | null;
  regionIdentifiers?: string[] | null;
  states?: string[] | null;
  orderBy?: OdProtosPartnershipData_ReportingSearchFilters_OrderBy | null;
  direction?: OdProtosPartnershipData_ReportingSearchFilters_Direction | null;
  after?: string | null;
  size?: number | null;
  salesReferrerUserId?: string | null;
  addressId?: string | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosPartnershipServices_AuthenticatedSearchSellerLeadsIndexRequestInput {
  searchFilters?: OdProtosPartnershipData_ReportingSearchFiltersInput | null;
}

/**
 * Next ID: 4
 */
export interface OdProtosPartnershipServices_GetEmbeddableReportsRequestInput {
  marketNameQueryParameters?: string[] | null;
  startDate?: any | null;
  endDate?: any | null;
}

/**
 * Next ID: 5
 */
export interface OdProtosWebData_VirtualAssessmentRecordingInput {
  id?: string | null;
  recordedFeature?: OdProtosWebData_RecordedFeature | null;
  fileName?: string | null;
  s3Directory?: string | null;
  preSignedRecordingUrl?: string | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosWebServicesMultipartUploads_MultipartUploadPartInput {
  partNumber?: number | null;
  etag?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

